module.exports = __webpack_public_path__ + "img/band.25e77979.jpg";